import { useMemo, useState } from 'react';
import { Grid, Chip, Button } from '@mui/material';
import { red, green } from '@mui/material/colors';
import { isArray, isEmpty, round } from 'lodash';
import DefectCheckDialog from './DefectCheckDialog';

export default function DefectCheckCell({ initial, onChange, editable }) {
  const [dialogOpen, setDialogOpen] = useState(false);

  const acceptableRatio = 0.5;

  const config = {
    acceptableRatio,
    options: ['Crown', 'Insects', 'Browning', 'Chilling', 'Crown', 'Insects'],
  };

  const { ratio, passing } = useMemo(() => {
    if (isEmpty(initial?.data) || !isArray(initial?.data)) {
      return {
        ratio: null,
        passing: null,
      };
    }

    const data = initial?.data;
    const ratio = round(data.filter((x) => x === 'ok').length / data.length, 2);
    const passing = ratio >= acceptableRatio;

    return {
      ratio,
      passing,
    };
  }, [initial, acceptableRatio]);

  return (
    <Grid container alignItems={'center'}>
      <Button
        fullWidth
        onClick={() => setDialogOpen(true)}
        sx={{ height: '100%', textTransform: 'none', justifyContent: 'start' }}
      >
        <Chip sx={{ mr: 1 }} label={`ok: ${ratio != null ? `${round(ratio * 100, 0)}%` : '-'}`} />
        {passing != null &&
          (passing ? (
            <Chip sx={{ background: green[500] }} label={'pass'} />
          ) : (
            <Chip sx={{ background: red[500] }} label={'fail'} />
          ))}
      </Button>

      <DefectCheckDialog
        open={dialogOpen}
        onClose={() => setDialogOpen(false)}
        config={config}
        editable={editable}
        initial={initial}
        onChange={onChange}
      />
    </Grid>
  );
}
